export default __webpack_public_path__ + "static/background-chemistry-5f34822752151db4eb0760becdcd2863.jpg";